import { availableAssets } from "../actions/assetsActionCreators";
import {
  SET_ASSETS,
  ADD_ASSET,
  UPDATE_ASSET,
  REMOVE_ASSET,
  SET_USER_ASSETS,
  SET_RISK_ASSETS,
  INFINTIE_ASSETS,
  SET_SEARCHED_ASSET,
  SET_ORGA_ASSETS,
  AVAILABLE_ASSETS, // <-- new import
} from "../types/assetsTypes";

const initialState = {
  all: [],
  selected: null,
  userAssets: [],
  orgaAssets: [], // <-- new state key for orga assets
  totalPages: 0,
  sources: [],
  riskAssets: [],
  infiniteAssets: [],
  businessFunctions: [],
  orphanedAssets: [],
  availableCategories: [], // pour filtrage
  availableAssets: [],
};

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AVAILABLE_ASSETS:
      return {
        ...state,
        availableAssets: action.payload,
      };
    case SET_ASSETS:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
      };
    case SET_ORGA_ASSETS:
      return {
        ...state,
        businessFunctions: action.payload.businessFunctions,
        orphanedAssets: action.payload.orphanedAssets,
        availableCategories: action.payload.availableCategories || [],
      };
    case INFINTIE_ASSETS:
      return {
        ...state,
        infiniteAssets: [...state.infiniteAssets, ...action.payload.items],
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCHED_ASSET:
      return {
        ...state,
        infiniteAssets: action.payload.items,
        totalPages: action.payload.totalPages,
      };
    case SET_RISK_ASSETS:
      return {
        ...state,
        riskAssets: action.payload,
      };
    case SET_USER_ASSETS:
      return {
        ...state,
        userAssets: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
      };
    case ADD_ASSET:
      return { ...state, all: [...state.all, action.payload] };
    case UPDATE_ASSET:
      return {
        ...state,
        all: state.all.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.data }
            : item
        ),
      };
    case REMOVE_ASSET:
      return {
        ...state,
        all: state.all.filter((item) => item.id !== action.payload),
      };

    default:
      return state;
  }
};

export default assetsReducer;
